import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines = [], className = "", delay = 0.1, onScroll = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "115%" }}
          {...(onScroll
            ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-40px" } }
            : { animate: { y: 0 } })}
          transition={{ duration: 1.05, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Kicker = ({ children, className = "", color }) => (
  <p
    className={`font-mono text-xs sm:text-sm tracking-[0.28em] uppercase ${className}`}
    style={color ? { color } : undefined}
  >
    {children}
  </p>
);
